import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/workflow/step";
import processId from "../../models/workflow/processId";
import steps from "../../models/workflow/steps";
import { processIf } from "@vue/compiler-dom";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    step: [],
    new: [],
    edit: [],
    deleteItem: [],
    processId: {},
    id: null,
  },

  mutations: {
    setStep(state, data) {
      state.step = data;
    },

    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
   
    setNew(state, data) {
      state.new = data;
    },
    setProcessId(state, data) {
      state.processId = data;
    },
    setId(state, data) {
      state.id = data;
    },
  },
  actions: {
      async getProcessId(state) {
            return new Promise(async (resolve, reject) => {
              try {
                let item = await state.state.service.getProcessId(state.state.id);
      
                state.commit("setProcessId", item);
                resolve(true);
              } catch (error) {
                reject(error);
              }
            });
          },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(() => {
            let item = state.state.edit;
 
            state.commit("setEdit", item);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then((data) => {
            let item = state.state.new;
           
            state.commit("setNew", item);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
           
            state.commit("setDeleteItem", state.state.deleteItem);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
